/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import {
  Link,
  // Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
} from "react-scroll";
import {
  Nav,
  NavLink,
  NavbarContainer,
  Span,
  NavLogo,
  NavItems,
  GitHubButton,
  ButtonContainer,
  MobileIcon,
  MobileMenu,
  // MobileNavLogo,
  MobileLink,
} from "./NavbarStyledComponent";
import { DiCssdeck } from "react-icons/di";
import { FaBars } from "react-icons/fa";
// import { Bio } from "../../data/constants";
import { useTheme } from "styled-components";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled, { keyframes } from "styled-components";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import NightsStayIcon from "@mui/icons-material/NightsStay";
import { SocialMediaIcon, ThemeMobileIcon } from "../HeroSection/HeroStyle";
import GitHubIcon from "@mui/icons-material/GitHub";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../axiosInstance";

// Wrap each FontAwesome icon and text in a container
const NavItemContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  ${
    "" /* .active-icon {
    font-size: 26px;
    color: #854ce6;
    transition: all 0.3s ease;
  } */
  }
`;

const Navbar = ({ toggleTheme, darkMode }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("about");
  const [github, setGithub] = useState("");
  const theme = useTheme();

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      try {
        const res = await axiosInstance.get("/bio");
        setGithub(res.data.github || "");
      } catch (err) {
        setGithub("");
      }
    }, 500);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    scrollSpy.update();
    Events.scrollEvent.register("begin", (to, element) => {
      setActiveSection(to);
    });

    return () => {
      Events.scrollEvent.remove("begin");
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to="/">
          <a
            style={{
              display: "flex",
              alignItems: "center",
              color: theme.logo,
              cursor: "pointer",
            }}
          >
            <DiCssdeck size="3rem" /> <Span>Portfolio</Span>
          </a>
        </NavLogo>
        <MobileIcon>
          <ThemeMobileIcon
            style={{ cursor: "pointer", marginRight: "35px" }}
            title="Github"
            href={github}
            target="_blank"
          >
            <GitHubIcon style={{ width: "25px", height: "25px" }} />
          </ThemeMobileIcon>
        </MobileIcon>

        <MobileIcon>
          <ThemeMobileIcon
            title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            onClick={toggleTheme}
            target="display"
            style={{ cursor: "pointer", marginRight: "15px" }}
          >
            {darkMode ? (
              <Brightness7Icon style={{ width: "25px", height: "25px" }} />
            ) : (
              <NightsStayIcon style={{ width: "25px", height: "25px" }} />
            )}
          </ThemeMobileIcon>
        </MobileIcon>

        <MobileIcon onClick={toggleMenu}>
          {isOpen ? <CloseIcon /> : <FaBars />}
        </MobileIcon>

        <NavItems>
          <Link
            to="about"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("about")}
          >
            <NavLink className={activeSection === "about" ? "active" : ""}>
              <NavItemContainer>
                <span
                  className={activeSection === "about" ? "active-text" : ""}
                >
                  About
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
          <Link
            to="skills"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("skills")}
          >
            <NavLink className={activeSection === "skills" ? "active" : ""}>
              <NavItemContainer>
                <span
                  className={activeSection === "skills" ? "active-text" : ""}
                >
                  Skills
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
          <Link
            to="experience"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("experience")}
          >
            <NavLink className={activeSection === "experience" ? "active" : ""}>
              <NavItemContainer>
                <span
                  className={
                    activeSection === "experience" ? "active-text" : ""
                  }
                >
                  Experience
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
          <Link
            to="projects"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("projects")}
          >
            <NavLink className={activeSection === "projects" ? "active" : ""}>
              <NavItemContainer>
                <span
                  className={activeSection === "projects" ? "active-text" : ""}
                >
                  Projects
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
          <Link
            to="education"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("education")}
          >
            <NavLink className={activeSection === "education" ? "active" : ""}>
              <NavItemContainer>
                <span
                  className={activeSection === "education" ? "active-text" : ""}
                >
                  Education
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
          <Link
            to="linkedin-insights"
            spy={true}
            smooth={true}
            duration={50}
            onSetActive={() => setActiveSection("linkedin-insights")}
          >
            <NavLink
              className={activeSection === "linkedin-insights" ? "active" : ""}
            >
              <NavItemContainer>
                <span
                  className={
                    activeSection === "linkedin-insights" ? "active-text" : ""
                  }
                >
                  LinkedIn
                </span>
              </NavItemContainer>
            </NavLink>
          </Link>
        </NavItems>

        <ButtonContainer>
          <GitHubButton href={github} target="_blank">
            <GitHubIcon style={{ marginRight: "5px" }} />
            Github
          </GitHubButton>

          <SocialMediaIcon
            title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            onClick={toggleTheme}
            target="display"
            style={{ cursor: "pointer" }}
          >
            {darkMode ? <Brightness7Icon /> : <NightsStayIcon />}
          </SocialMediaIcon>
        </ButtonContainer>
        {isOpen && (
          <MobileMenu isOpen={isOpen}>
            <MobileLink href="#about" onClick={toggleMenu}>
              About
            </MobileLink>
            <MobileLink href="#skills" onClick={toggleMenu}>
              Skills
            </MobileLink>
            <MobileLink href="#experience" onClick={toggleMenu}>
              Experience
            </MobileLink>
            <MobileLink href="#projects" onClick={toggleMenu}>
              Projects
            </MobileLink>
            <MobileLink href="#education" onClick={toggleMenu}>
              Education
            </MobileLink>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
